import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";
import QcTutorialPage from "../pages/qc-tutorial/page";
import BestFindsPage from "../pages/best-finds/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/cssbuy-qc-tutorial",
    element: <QcTutorialPage />,
  },
  {
    path: "/cssbuy-best-finds-2026",
    element: <BestFindsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;